import { Deserializable } from '../../protocols/deserializable';
import { AccountTypeIdEnum } from '../../enum/shared/account-type-id.enum';
import { MonthlyPensionAnnuityTypeIdEnum } from '../../enum/shared/monthly-pension-annuity-type-id.enum';
import { AnnuityGuaranteeTypeIdEnum } from '../../enum/shared/annuity-guarantee-type-id.enum';
import { GoverningJurisdictionTypeId } from '../../enum/shared/governing-jurisdiction-type-id';
import { MemberDeathRecordSettlement } from './member-death-record-settlement';

export class MemberDeathRecordAccount implements Deserializable {
  public id!: number;
  public deathRecordId!: number;
  public accountId!: number;
  public accountTypeId!: AccountTypeIdEnum;
  public annuityTypeId: MonthlyPensionAnnuityTypeIdEnum | null = null;
  public annuityGuaranteePeriodId: AnnuityGuaranteeTypeIdEnum | null = null;
  public governingJurisdictionId: GoverningJurisdictionTypeId | null = null;
  public balance: number | null = null;
  public label: string | null = null;
  public allowedSettlementTypeIds: number[] = [];
  public settlements: MemberDeathRecordSettlement[] = [];

  public isMonthlyPension!: boolean;

  public onDeserialize(): void {
    this.settlements = window.injector.Deserialize.arrayOf(MemberDeathRecordSettlement, this.settlements ?? []);
    this.isMonthlyPension = this.accountTypeId === AccountTypeIdEnum.MonthlyPension;
  }
}
